export const getRange = () => {
  const selection = getSelection();
  const range = selection?.getRangeAt(0);
  if (!range) throw new Error("No range found");

  return range;
};
